module.exports = __webpack_public_path__ + "static/img/OOSH_058.4b62708.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/OOSH_058.jpg
// module id = u2ue
// module chunks = 170